import { startCase } from 'lodash';

import { HealthQuoteMember } from '@store/healthquote';
import { Stack, Text } from '@ui';
import { MALE } from '@utils/constants';

export const CARE_NOMINEE_SALUTATIONS = [
  { label: 'MR', value: 'MR' },
  { label: 'MS', value: 'MS' }
];

const COMMON_CARE_NOMINEE_RELATIONSHIPS = [
  { label: 'Father', value: 'Father' },
  { label: 'Mother', value: 'Mother' },
  { label: 'Daughter', value: 'Daughter' },
  { label: 'Son', value: 'Son' },
  { label: 'Brother', value: 'Brother' },
  { label: 'Grandfather', value: 'Grandfather' },
  { label: 'Grandmother', value: 'Grandmother' },
  { label: 'Brother in law', value: 'Brother-in-law' },
  { label: 'Mother in law', value: 'Mother-in-law' },
  { label: 'Sister in law', value: 'Sister-in-law' },
  { label: 'Sister', value: 'Sister' }
];

export const CARE_NOMINEE_RELATIONSHIPS = [
  { label: 'Spouse', value: 'Spouse' },
  ...COMMON_CARE_NOMINEE_RELATIONSHIPS
];

export const CARE_NOMINEE_APPOINTEE_RELATIONSHIPS = [
  { label: 'Wife', value: 'WIFE' },
  { label: 'Husband', value: 'HUSBAND' },
  ...COMMON_CARE_NOMINEE_RELATIONSHIPS
];

export const SOMEONE_ELSE = 'Someone else';

export const DECLARATION_1 =
  'I hereby declare, on my behalf and on behalf of all persons proposed to be insured, that the above statements, answers and/or particulars given by me are true and complete in all respects to the best of my knowledge and that I am authorised to propose on behalf of these other persons.';

export const DECLARATION_2 =
  'I understand that the information provided by me will form the basis of the insurance policy, is subject to the Board approved underwriting policy of the insurer and that the policy will come into force only after full payment of the premium chargeable.';

export const DECLARATION_3 =
  'I authorise the company to share information pertaining to my proposal including the medical records of the insured/proposer for the sole purpose of underwriting the proposal and/or claims settlement and with any Governmental and/or Regulatory Authority.';

export const CareTermsConditions = [
  <Stack key="tnc1">
    <Text c="secondary">{DECLARATION_1}</Text>
    <Text c="secondary">{DECLARATION_2}</Text>
    <Text c="secondary">{DECLARATION_3}</Text>
  </Stack>
];

export const CARE_PORTING_REASONS = [
  { value: 'CHEQUE BOUNCE', label: 'Cheque Bounce' },
  { value: 'POLICY ADITION OR DELETION', label: 'Policy Addition Or Deletion' },
  { value: 'PRODUCT CHANGE', label: 'Product Change' },
  { value: 'POLICY MERGING', label: 'Policy Merging' },
  { value: 'POLICY SPLIT', label: 'Policy Split' }
];

export const CARE_PORTING_POLICY_TERMS = ['1', '2', '3'].map((value) => ({
  label: String(value),
  value
}));

const sentenceCaseLabelPredicate = (label: string) => {
  const lowerCaseLabel = label.toLowerCase();
  const sentenceCaseLabel = startCase(lowerCaseLabel);
  return { value: label, label: sentenceCaseLabel };
};

export const CARE_PORTING_INSURERS = [
  'THE NEW INDIA ASSURANCE CO. LTD.',
  'NATIONAL INSURANCE COMPANY LIMITED',
  'THE ORIENTAL INSURANCE CO. LTD',
  'UNITED INDIA INSURANCE CO. LTD.',
  'Apollo Munich Health Insurance Co Ltd',
  'STAR HEALTH AND ALLIED INSURANCE CO.LTD',
  'MAX Bupa Health Insurance Company Ltd.',
  'ICICI LOMBARD GENERAL INSURANCE CO. LTD.',
  'BAJAJ ALLIANZ GENERAL INSURANCE CO. LTD.',
  'RELIANCE GENERAL INSURANCE COMPANY LTD.',
  'TATA AIG GENERAL INSURANCE COMPANY LTD',
  'SBI GENERAL INSURANCE COMPANY LTD',
  'UNIVERSAL SOMPO GENERAL INSURANCE CO.LTD',
  'HDFC ERGO GENERAL INSURANCE COMPANY LTD',
  'FUTURE GENERALI INDIA INSURANCE CO.LTD',
  'BHARTI AXA GENERAL INSURANCE CO. LTD',
  'ROYAL SUNDARAM ALLIANCE INSURANCE CO LTD',
  'IFFCO TOKIO GENERAL INSURANCE CO. LTD.',
  'CHOLAMANDALAM MS GENERAL INSURANCE COLTD',
  'RAHEJA QBE GENERAL INS. CO. LTD',
  'SHRIRAM GENERAL INS. CO. LTD',
  'CARE HEALTH INSURANCE CO.',
  'L&T General Insurance Company Limited',
  'CignaTTK Health Insurance Company Limited',
  'LIBERTY VIDEOCON GENERAL INSURANCE Co. Ltd',
  'KOTAK GENERAL INSURANCE',
  'GROUP RETAIL PREVIOUS POLICY INSURER',
  'ADITYA BIRLA INSURANCE',
  'EDELWEISS HEALTH INSURANCE',
  'Magma HDI General Insurance Company Limited',
  'DIGIT HEALTH CARE PLUS POLICY'
].map(sentenceCaseLabelPredicate);

// Claim reasons for porting
export const CARE_CLAIM_REASONS = [
  { value: 'Calculus of urinary tract', label: 'Calculus of urinary tract' },
  { value: 'Cutaneous abscess, furuncle', label: 'Cutaneous abscess, furuncle' },
  {
    value: 'Erosion and ectropion of cervical',
    label: 'Erosion and ectropion of cervical'
  },
  { value: 'Other immunodeficiencies', label: 'Other immunodeficiencies' },
  { value: 'Cardiac arrest', label: 'Cardiac arrest' },
  { value: 'Malignant neoplasm of kidney', label: 'Malignant neoplasm of kidney' },
  { value: 'Acute pharyngitis', label: 'Acute pharyngitis' },
  {
    value: 'Other and unspecified injuries of Forearm',
    label: 'Other and unspecified injuries of Forearm'
  },
  { value: 'Cystitis', label: 'Cystitis' },
  { value: 'Other abortion', label: 'Other abortion' },
  {
    value: 'Specific developmental disorders of speech and language',
    label: 'Specific developmental disorders of speech and language'
  },
  { value: 'Injury of unspecified of body', label: 'Injury of unspecified of body' },
  { value: 'Other retinal disorders', label: 'Other retinal disorders' },
  { value: 'Unspecified viral hepatitis', label: 'Unspecified viral hepatitis' },
  { value: 'Acute sinusitis', label: 'Acute sinusitis' },
  {
    value: 'Other diseases of lip and oral',
    label: 'Other diseases of lip and oral'
  },
  { value: 'Fracture of rib(s), sternum', label: 'Fracture of rib(s), sternum' },
  { value: 'Intracerebral haemorrhage', label: 'Intracerebral haemorrhage' },
  { value: 'Other disorders of middle ear', label: 'Other disorders of middle ear' },
  { value: 'Lymphoid leukaemia', label: 'Lymphoid leukaemia' },
  { value: 'Acute bronchitis', label: 'Acute bronchitis' },
  {
    value: 'Other disorders of eye and adnexa',
    label: 'Other disorders of eye and adnexa'
  },
  { value: 'Other disorders of penis', label: 'Other disorders of penis' },
  { value: 'Tuberculosis of other organs', label: 'Tuberculosis of other organs' },
  { value: 'Dizziness and giddiness', label: 'Dizziness and giddiness' },
  { value: 'Other disorder of kidney', label: 'Other disorder of kidney' },
  { value: 'Normal Delivery', label: 'Normal Delivery' },
  { value: 'Caesarean Delivery', label: 'Caesarean Delivery' },
  { value: 'Diarrhoea and gastroenteritis', label: 'Diarrhoea and gastroenteritis' },
  { value: 'Perianal Abscess', label: 'Perianal Abscess' },
  { value: 'Epilepsy (Related to Seizure)', label: 'Epilepsy (Related to Seizure)' },
  { value: 'Angina Pectoris', label: 'Angina Pectoris' },
  { value: 'Carcinoma Bladder', label: 'Carcinoma Bladder' },
  // NOTE: Do not change the value, API expects the typo
  { value: 'Cholecytitis', label: 'Cholecystitis' },
  {
    value: 'Bacterial Pneumonia, not elsewhere',
    label: 'Bacterial Pneumonia, not elsewhere'
  },
  { value: 'Acute Myocardial Infection', label: 'Acute Myocardial Infection' },
  { value: 'Other Congenital malformation', label: 'Other Congenital malformation' },
  { value: 'Typhoid and Paratyphoid', label: 'Typhoid and Paratyphoid' },
  {
    value: 'Chronic ischemic heart disease',
    label: 'Chronic ischemic heart disease'
  },
  { value: 'Dengue Fever', label: 'Dengue Fever' },
  {
    value: 'Plasmodium Falciparum Malaria(Smear Negative Malaria)',
    label: 'Plasmodium Falciparum Malaria(Smear Negative Malaria)'
  },
  {
    value: 'Localized swelling and Mass(Lipomatosis)',
    label: 'Localized swelling and Mass(Lipomatosis)'
  },
  { value: 'Other paralytic Syndromes', label: 'Other paralytic Syndromes' },
  { value: 'Dislocation sprain and strain', label: 'Dislocation sprain and strain' },
  { value: 'Fibroid Uterus', label: 'Fibroid Uterus' },
  { value: 'Pseudophakia', label: 'Pseudophakia' },
  { value: 'Urethral Stricture', label: 'Urethral Stricture' },
  { value: 'Inguinal Hernia', label: 'Inguinal Hernia' },
  {
    value: 'Motor cycle rider injured to other and unspecified accident',
    label: 'Motor cycle rider injured to other and unspecified accident'
  },
  { value: 'Vitamin B12 deficiency anemia', label: 'Vitamin B12 deficiency anemia' },
  { value: 'Carcinoma in situ of other', label: 'Carcinoma in situ of other' },
  {
    value: 'Seizure or Respiratory distress in New born baby',
    label: 'Seizure or Respiratory distress in New born baby'
  },
  { value: 'Fever of unknown origin', label: 'Fever of unknown origin' },
  { value: "Crohn's disease", label: "Crohn's disease" },
  { value: 'Leiomyoma of uterus', label: 'Leiomyoma of uterus' },
  { value: 'Gastritis and duodenitis', label: 'Gastritis and duodenitis' },
  {
    value: 'Benign neoplasm of thyroid gland',
    label: 'Benign neoplasm of thyroid gland'
  },
  {
    value: 'Fracture at wrist and hand level',
    label: 'Fracture at wrist and hand level'
  },
  { value: 'Senile cataract', label: 'Senile cataract' },
  {
    value: 'Pleural effusion, not elsewhere',
    label: 'Pleural effusion, not elsewhere'
  },
  {
    value: 'Malignant neoplasm of other and unspecified major salivary glands',
    label: 'Malignant neoplasm of other and unspecified major salivary glands'
  },
  {
    value: 'Hypofunction and other disorders of pituitary gland',
    label: 'Hypofunction and other disorders of pituitary gland'
  },
  { value: 'Acute appendicitis', label: 'Acute appendicitis' },
  { value: 'Fracture of lower leg', label: 'Fracture of lower leg' },
  { value: 'Other abortion(D & C)', label: 'Other abortion(D & C)' },
  { value: 'Care involving dialysis', label: 'Care involving dialysis' },
  { value: 'Other disorders of eye', label: 'Other disorders of eye' },
  { value: 'Disorders of oesophagus', label: 'Disorders of oesophagus' },
  {
    // NOTE: Do not change the value, API expects the typo
    value: 'Pain and other conditionsans and menstrual cycle',
    label: 'Pain and other conditions and menstrual cycle'
  },
  {
    value: 'Oedema, not elsewhere classified',
    label: 'Oedema, not elsewhere classified'
  },
  { value: 'Cholelithiasis', label: 'Cholelithiasis' },
  { value: 'Unspecified lump in breast', label: 'Unspecified lump in breast' },
  { value: 'Carcinoma in situ of breast', label: 'Carcinoma in situ of breast' },
  { value: 'Cerebral infarction', label: 'Cerebral infarction' },
  {
    value: 'Convulsions, not elsewhere classified.',
    label: 'Convulsions, not elsewhere classified.'
  },
  {
    value: 'Fissure and fistula of anal and rectal regions',
    label: 'Fissure and fistula of anal and rectal regions'
  },
  { value: 'Other disorders of brain', label: 'Other disorders of brain' },
  { value: 'Respiratory tuberculosis', label: 'Respiratory tuberculosis' },
  { value: 'Ventral hernia', label: 'Ventral hernia' },
  {
    value: 'Other and unspecified injuries',
    label: 'Other and unspecified injuries'
  },
  { value: 'Other acute ischaemic heart', label: 'Other acute ischaemic heart' },
  {
    // NOTE: Do not change the value, API expects the typo
    value: 'Essential (primary) hypertensi',
    label: 'Essential (primary) hypertension'
  },
  { value: 'Malignant neoplasm of ovary', label: 'Malignant neoplasm of ovary' },
  { value: 'Unspecified malaria', label: 'Unspecified malaria' },
  { value: 'Spondylosis', label: 'Spondylosis' },
  { value: 'Superficial injury of head', label: 'Superficial injury of head' },
  {
    value: 'Unspecified acute lower respiratory infection',
    label: 'Unspecified acute lower respiratory infection'
  },
  { value: 'Thalassaemia', label: 'Thalassaemia' },
  { value: 'Other disorders of fluid', label: 'Other disorders of fluid' },
  { value: 'Neonatal jaundice from other', label: 'Neonatal jaundice from other' },
  { value: 'Abdominal and pelvic pain', label: 'Abdominal and pelvic pain' },
  { value: 'Other disorders of nose', label: 'Other disorders of nose' },
  {
    // NOTE: Do not change the value, API expects the typo
    value: 'Other noninfective gastroenter',
    label: 'Other noninfective gastroenteritis'
  },
  { value: 'Fracture of skull and facial', label: 'Fracture of skull and facial' },
  {
    value: 'Stroke, not specified as haemo',
    label: 'Stroke, not specified as haemo'
  },
  { value: 'Other systemic involvement of', label: 'Other systemic involvement of' },
  { value: 'Other arthritis', label: 'Other arthritis' },
  { value: 'Chronic renal failure', label: 'Chronic renal failure' }
];

export const POLICY_COVERAGE_TYPE = [
  { label: 'Individual', value: 'INDIVIDUAL' },
  { label: 'Floater', value: 'FLOATER' }
];

export const SpouseRelations = {
  HUSBAND: 'Husband',
  WIFE: 'Wife'
};

// For Care products, relation to the nominee should be changed to
// SpouseRelations when Spouse is selected as the relation during proposal submission
export const getSpouseRelation = (gender: string) =>
  gender === 'Male' ? SpouseRelations.WIFE : SpouseRelations.HUSBAND;

// The backend stores the nominee relation as SpouseRelations which should be changed to
// Spouse for the client
export const isSpouse = (relation: string) =>
  [SpouseRelations.HUSBAND, SpouseRelations.WIFE].includes(relation);

export const getTitleByRelation = (
  relation: HealthQuoteMember,
  proposerGender: string
) => {
  switch (relation) {
    case HealthQuoteMember.Father:
      return 'MR';
    case HealthQuoteMember.Mother:
      return 'MS';
    case HealthQuoteMember.Son:
      return 'MR';
    case HealthQuoteMember.Daughter:
      return 'MS';
    case HealthQuoteMember.FatherInLaw:
      return 'MR';
    case HealthQuoteMember.MotherInLaw:
      return 'MS';
    case HealthQuoteMember.Spouse:
      if (proposerGender === MALE) {
        return 'MS';
      } else {
        return 'MR';
      }
    default:
      return undefined;
  }
};

export const NOT_SERVICEABLE = 'NOT_SERVICEABLE';
